var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { PureComponent } from 'react';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import styles from './replyStatus.module.scss';
export class ReplyStatus extends PureComponent {
    componentDidMount() {
        // warn about deprecated props
        const { isAssigned } = this.props;
        if (isAssigned) {
            // eslint-disable-next-line no-console
            console.warn('Warning: Prop isAssigned is deprecated on ReplyStatus.');
        }
    }
    render() {
        const _a = this.props, { className, isClosed, isNotYours, isAssigned, showClaimButton, showTakeoverButton, onClaim, customText, explanation, onCall, onCompose } = _a, otherProps = __rest(_a, ["className", "isClosed", "isNotYours", "isAssigned", "showClaimButton", "showTakeoverButton", "onClaim", "customText", "explanation", "onCall", "onCompose"]);
        const rootClass = classnames({
            [styles.root]: true,
        }, className);
        let statusText = typeof customText === 'string' ? customText : undefined;
        let showClaim = typeof showClaimButton === 'boolean' ? showClaimButton : false;
        let showTakeOver = typeof showTakeoverButton === 'boolean' ? showTakeoverButton : false;
        if (isClosed) {
            statusText = !statusText ? 'This conversation is closed' : statusText;
        }
        else if (isNotYours) {
            statusText = !statusText
                ? 'You need to be assigned to reply'
                : statusText;
            if (!showClaim && !showTakeOver) {
                showClaim = !isAssigned;
                showTakeOver = Boolean(isAssigned);
            }
        }
        const hasOtherActions = onCall || onCompose;
        const claimTooltipContent = (label) => (_jsx(CommandKeybindingsTooltipContent, Object.assign({ commandName: "conversation:claim" }, { children: label })));
        return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [explanation && _jsx("h2", Object.assign({ className: styles.explanation }, { children: explanation })), _jsx("h2", Object.assign({ className: styles.title }, { children: statusText })), showClaim && (_jsx(Tooltip, Object.assign({ dark: true, content: claimTooltipContent('Claim conversation') }, { children: _jsx(Button, Object.assign({ onClick: onClaim }, { children: "Claim conversation" })) }))), showTakeOver && (_jsx(Tooltip, Object.assign({ dark: true, content: claimTooltipContent('Take over conversation') }, { children: _jsx(Button, Object.assign({ onClick: onClaim }, { children: "Take over conversation" })) }))), (showClaim || showTakeOver) && hasOtherActions && (_jsx("span", Object.assign({ className: styles.actionDivider }, { children: "Or" }))), _jsxs("div", Object.assign({ className: styles.actions }, { children: [onCall && (_jsx(Button, Object.assign({ variant: "secondary", className: styles.action, onClick: onCall }, { children: "Make call" }))), onCompose && (_jsx(Button, Object.assign({ variant: "secondary", className: styles.action, onClick: onCompose }, { children: "Compose an email" })))] }))] })));
    }
}
